import {
  error,
  institution,
  money,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const SubmitTransfer = gql`
  mutation SubmitTransfer(
    $idempotencyId: String!
    $sourceAccountId: ID!
    $destinationAccountId: ID!
    $amount: Decimal!
    $currency: Currency!
  ) {
    submitTransfer(
      idempotencyId: $idempotencyId
      input: {
        sourceAccountId: $sourceAccountId
        destinationAccountId: $destinationAccountId
        amount: $amount
        currency: $currency
      }
    ) {
      __typename
      ... on SubmitTransferError {
        ...error
      }

      ... on SubmitTransferSuccess {
        id
        tileIdsToRefresh
        transferSpeedMessage
        transfer {
          status
          value {
            ...money
          }
          sourceAccount {
            id
            name
            accountNumber
            type
            product
            institution {
              ...institution
            }
          }
          destinationAccount {
            id
            name
            accountNumber
            type
            product
            institution {
              ...institution
            }
          }
        }
      }
    }
  }
  ${institution}
  ${money}
  ${error}
`;
export default SubmitTransfer;
